export const bannerSettings = {
  contentDirection: 'column',
  layout: 'vertical',
  stretchBackground: false,
  bannerBackground: undefined,
  bannerWidth: 500,
  verticalBannerHeight: {
    auto: true,
    customValue: 400
  },
  horizontalBannerHeight: {
    auto: true,
    customValue: 400
  },
  contentAlignment: {
    position: 'top-left'
  },
  contentPadding: 40,
  contentSpacing: 20,

  blocks: []
} as const;
